export default [
  ['=', '+', '%', '*', '[', ']', '{', '}', '<', '>'],
  ['@', ':', ';', '_', '-', '#', '(', ')', '/', '\\'],
  ['.', ',', '?', '!', '\'', '"', '^'],
];



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/keyboard/layouts/SymbolsLayout.jsx